import { ExampleSearchInlineEditComponent } from './pages/example-search-inline-edit/example-search-inline-edit.component';
import { ExampleDoubleComponent } from './pages/example-double/example-double.component';
import { ExampleFormComponent } from './pages/example-form/example-form.component';
import { ExampleSingleComponent } from './pages/example-single/example-single.component';
import { ExampleSearchComponent } from './pages/example-search/example-search.component';
import { ExampleComponent } from './pages/example/example.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WindowPopstateGuard } from '../guards/window-popstate.guard';
import { ExampleInlineEditComponent } from './pages/example-inline-edit/example-inline-edit.component';
import { ExampleUploadComponent } from './pages/example-upload/example-upload.component';

const routes: Routes = [
  {
    path: '',
    component: ExampleComponent
  },
  {
    path: 'base',
    component: ExampleFormComponent,
    data: {
      breadcrumb: '基本表單',
      breadcrumbDisabled: true
    }
  },
  {
    path: 'search-single',
    component: ExampleSearchComponent,
    data: {
      breadcrumb: '查詢 + 單檔',
      breadcrumbDisabled: true
    },
    canDeactivate: [WindowPopstateGuard]
  },
  {
    path: 'single/:uuid',
    component: ExampleSingleComponent,
    data: {
      breadcrumb: '單檔 (直接開啟)',
      breadcrumbDisabled: true
    }
  },
  {
    path: 'search-double',
    component: ExampleSearchComponent,
    data: {
      breadcrumb: '查詢 + 雙檔',
      breadcrumbDisabled: true
    },
    canDeactivate: [WindowPopstateGuard]
  },
  {
    path: 'double/:uuid',
    component: ExampleDoubleComponent,
    data: {
      breadcrumb: '雙檔 (直接開啟)',
      breadcrumbDisabled: true
    }
  },
  {
    path: 'inline-edit/:uuid',
    component: ExampleInlineEditComponent,
    data: {
      breadcrumb: 'Inline Edit (直接開啟)',
      breadcrumbDisabled: true
    }
  },
  {
    path: 'upload',
    component: ExampleUploadComponent,
    data: {
      breadcrumb: 'Excel 檔案上傳預覽',
      breadcrumbDisabled: true
    }
  },
  {
    path: 'search-inline-edit',
    component: ExampleSearchInlineEditComponent,
    data: {
      breadcrumb: '查詢結果 Inline Edit',
      breadcrumbDisabled: true
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExampleRoutingModule { }
